module.exports = __webpack_public_path__ + "img/bell.caca4148.png";